export const FETCH_EVALUATION_PERIOD = "FETCH_PERFORMANCE_PERIOD";
export const CREATE_EVALUATION_PERIOD = "CREATE_PERFORMANCE_PERIOD";
export const DELETE_EVALUATION_PERIOD = "DELETE_PERFORMANCE_PERIOD";
export const FETCH_EVALUATION_TYPE_DDL = "FETCH_EVALUATION_DDL";
export const EDIT_EVALUATION_DETAILS = "EDIT_PERFORMANCE_DETAILS";
export const DELETE_EVALUATION_DETAILS = "DELETE_PERFORMANCE_DETAILS";
export const LOCK_EVALUATION_DETAILS = "LOCK_PERFORMANCE_DETAILS";
